<template>
  <div>
    <div v-if="otherVersions.length" class="select-box">
      <select v-model="selectedVersion" @change="onChangeSelectedVersion">
        <option v-for="version of otherVersions" :key="version" :value="version">{{ version }}</option>
      </select>
    </div>
    <div class="document">
      <component ref="doc" :is="document" class="md" />
    </div>
  </div>
</template>
<script>
import { VersionManager, updateSellerName } from '../documentManager'

export default {
  data() {
    const { service, paper, type } = this.$route.params
    const { seller, v } = this.$route.query

    const versionManager = new VersionManager(service, paper, type, v)

    return {
      service,
      paper,
      type,
      seller,
      version: v,
      selectedVersion: versionManager.getVersion()
    }
  },
  methods: {
    onChangeSelectedVersion() {
      location.href = `${this.$route.path}?v=${this.selectedVersion}`
    }
  },
  computed: {
    document() {
      const versionManager = new VersionManager(this.service, this.paper, this.type, this.version)
      return () => versionManager.getDocument()
    },
    otherVersions() {
      const versionManager = new VersionManager(this.service, this.paper, this.type, this.version)
      return versionManager.getOtherVersions()
    }
  },
  updated() {
    updateSellerName.call(this, this.seller)
  }
}
</script>
